export var AgentTaskStatus;
(function (AgentTaskStatus) {
    AgentTaskStatus["COMPLETE"] = "complete";
    AgentTaskStatus["IN_PROGRESS"] = "in_progress";
    AgentTaskStatus["CANCELLED"] = "cancelled";
})(AgentTaskStatus || (AgentTaskStatus = {}));
